import apiClient from '../../services/apiClient';
import type { Announcement, CreateAnnouncementRequest, UpdateAnnouncementRequest, AttachmentInfo } from './models';

export async function listAnnouncements(page = 1, size = 20, status?: string): Promise<{ items: Announcement[]; total: number }> {
  const params: Record<string, string | number> = { page, size };
  if (status) params.status = status;
  const res = await apiClient.get('/api/system-announcements/list', { params });
  return res.data.data;
}

export async function getAnnouncement(id: string): Promise<Announcement> {
  const res = await apiClient.get(`/api/system-announcements/${id}`);
  return res.data.data;
}

export async function createAnnouncement(data: CreateAnnouncementRequest): Promise<Announcement> {
  const res = await apiClient.post('/api/system-announcements', data);
  return res.data.data;
}

export async function updateAnnouncement(id: string, data: UpdateAnnouncementRequest): Promise<Announcement> {
  const res = await apiClient.put(`/api/system-announcements/${id}`, data);
  return res.data.data;
}

export async function deleteAnnouncement(id: string): Promise<void> {
  await apiClient.delete(`/api/system-announcements/${id}`);
}

export async function uploadAnnouncementFile(file: File): Promise<AttachmentInfo> {
  const formData = new FormData();
  formData.append('file', file);
  const res = await apiClient.post('/api/system-announcements/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}

export async function markAnnouncementRead(id: string): Promise<void> {
  await apiClient.post(`/api/system-announcements/${id}/read`);
}

export async function getUnreadAnnouncementCount(): Promise<number> {
  const res = await apiClient.get('/api/system-announcements/unread-count');
  return res.data.data.count;
}
